import { axiosDelete } from '@/api/AxiosApi';
import { sendRequest, EndpointPayload } from '@/api/AxiosRequest';

const BALANCE_API_URL = process.env.REACT_APP_BALANCE_API_URL;

// 관리자 지갑 삭제
export const deleteAdminWallet = async (walletId: string) => {
  const payload: EndpointPayload = {
    path: `/assetfi/admin/staking/wallets/${walletId}`,
    apiUrl: BALANCE_API_URL,
  };

  return await sendRequest(payload, 'deleteAdminWallet', axiosDelete);
};
